import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for the stock-counts sub-tree (register at `/silo-counts/counts`,
 * detail at `/silo-counts/counts/$countId`) — mirrors the app-root
 * `_authenticated.tsx` + `_authenticated/` nesting pattern. No chrome of its own;
 * the parent `silo-counts.tsx` layout already renders the tab strip. */
export const Route = createFileRoute('/_authenticated/silo-counts/counts')({
  component: () => <Outlet />,
});
